// The error codes are defined here:
// https://learn.microsoft.com/en-us/azure/active-directory-b2c/error-codes
export enum AuthErrorCodeType {
  ForgetPassword = 'AADB2C90118',
}

export enum BrowserAuthErrorCodeType {
  NoAccountError = 'no_account_error',
}
